import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||1623}
    height={props.width? `calc( ${props.width}/ 1623 * 854 )`: 854}
    viewBox="0 0 1623 854"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillOpacity={0.8}
      stroke="#fff"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="m1563.34 557.785 58.66 58.714v236.056H74.559L1 778.928V278.422l47.415-47.45V2H1476.67l86.02 86.111.65 469.674Z"
    />
    <path
      fill="url(#agh)"
      fillOpacity={0.5}
      stroke="#fff"
      strokeWidth={2}
      d="m606.982 74.39.297-.294V1H49.451v102.88h527.655l.292-.288 29.584-29.203Z"
    />
    {/* <path
      fill="#000"
      d="M250.547 65.758V44.302h-7.236v-5.364h20.952v5.364h-7.272v21.456h-6.444Zm22.751.504c-5.22 0-10.044-3.96-10.044-10.764 0-6.768 4.824-10.728 10.044-10.728 5.184 0 10.008 3.96 10.008 10.728 0 6.804-4.824 10.764-10.008 10.764Zm0-5.184c2.376 0 3.456-2.16 3.456-5.58 0-3.384-1.08-5.544-3.456-5.544-2.412 0-3.492 2.16-3.492 5.544 0 3.42 1.08 5.58 3.492 5.58Zm20.688 5.184c-5.148 0-7.236-3.276-7.236-8.1v-7.884h-2.772v-4.752l3.168-.252.72-5.436h5.292v5.436h4.824v5.004h-4.824v7.812c0 2.268 1.08 3.168 2.592 3.168.648 0 1.368-.216 1.872-.396l1.008 4.644c-1.08.324-2.556.756-4.644.756Zm12.026 0c-3.78 0-6.084-2.808-6.084-6.228 0-4.32 3.384-6.66 11.376-7.524-.144-1.656-1.008-2.628-3.096-2.628-1.62 0-3.312.648-5.364 1.8l-2.232-4.212c2.7-1.62 5.616-2.7 8.82-2.7 5.292 0 8.28 2.952 8.28 9.36v11.628h-5.22l-.432-2.052h-.18c-1.692 1.512-3.6 2.556-5.868 2.556Zm2.196-4.968c1.296 0 2.16-.612 3.096-1.62v-3.276c-3.996.504-5.292 1.692-5.292 3.132 0 1.188.864 1.764 2.196 1.764Zm20.284 4.968c-4.392 0-5.832-2.88-5.832-7.164V36.994h6.408v22.32c0 1.368.612 1.764 1.116 1.764.216 0 .36 0 .72-.072l.756 4.716c-.684.288-1.728.54-3.168.54Zm14.852-.504v-26.82h9.432c5.868 0 10.728 2.124 10.728 8.748 0 6.372-4.896 9.18-10.584 9.18h-3.132v8.892h-6.444Zm6.444-13.968h2.808c3.132 0 4.644-1.476 4.644-4.104 0-2.7-1.728-3.636-4.824-3.636h-2.628v7.74Zm29.611 14.472c-6.804 0-12.564-4.68-12.564-13.752 0-8.928 5.976-14.04 12.78-14.04 3.492 0 6.3 1.62 8.136 3.492l-3.348 4.104c-1.368-1.224-2.772-2.088-4.68-2.088-3.456 0-6.3 3.096-6.3 8.316 0 5.328 2.448 8.424 6.228 8.424 2.16 0 3.852-1.08 5.112-2.448l3.384 4.032c-2.268 2.628-5.256 3.96-8.748 3.96Zm12.672-.504v-26.82h9.828c5.724 0 10.476 1.98 10.476 8.46 0 6.3-4.752 8.928-10.476 8.928h-3.384v9.432h-6.444Zm6.444-14.508h2.88c3.06 0 4.716-1.332 4.716-3.852 0-2.52-1.656-3.348-4.716-3.348h-2.88v7.2Zm8.028 14.508-5.796-11.088 4.356-4.212 8.64 15.3h-7.2Z" */}
    />
    <path fill="#67FFED" d="M35.616 2h-6.532L1 29.692h6.531L35.616 2Z" />
    <path
      fill="#fff"
      d="M35.616 209.694h-6.532L1 237.386h6.531l28.085-27.692ZM35.616 179.034h-6.532L1 206.727h6.531l28.085-27.693Z"
    />
    <defs>
      <linearGradient
        id="agh"
        x1={-137.688}
        x2={-137.688}
        y1={102.88}
        y2={2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.51} stopColor="#E9FFFE" stopOpacity={0.49} />
        <stop offset={1} stopColor="#6AFFF6" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
